import { Avatar, Card, Col, Layout, Row, Image, Rate, Badge } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import ShopSidebar from "./sidebar";

import { PhoneFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const ShopLayout = ({
  children,
  shopId,
}: {
  children: ReactElement;
  shopId: string;
}): ReactElement => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content_">
                      <div className="shop-banner">
                        <Image
                          src={getImgUrl(shopInfo?.banner)}
                          alt={shopInfo?.name}
                          className="rounded"
                          width="100%"
                        />
                      </div>

                      <div className="shop-image-content">
                        <div className="shop-logo">
                          <Avatar
                            shape="circle"
                            size={95}
                            src={getImgUrl(shopInfo?.logo)}
                          />
                        </div>
                        <div className="body">
                          <h6 className="d-flex align-items-center mb-0">
                            {shopInfo?.name?.toUpperCase()}
                            <Badge>
                              {shopInfo?.status?.toUpperCase() === "OPEN" ? (
                                <FontAwesomeIcon
                                  icon={faCheckCircle}
                                  className="text-success ml-2"
                                />
                              ) : shopInfo?.status?.toUpperCase() === "BUSY" ? (
                                <FontAwesomeIcon
                                  icon={faExclamationTriangle}
                                  className="text-warning ml-2"
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="text-danger ml-2"
                                />
                              )}
                            </Badge>
                          </h6>
                          <div className="mb-0">
                            <div>
                              <span className="radius-btn active-btn">
                                <span>
                                  <PhoneFilled />{" "}
                                  {shopInfo?.mobileNumber?.split("+88")}
                                </span>
                              </span>
                            </div>
                            <Rate
                              value={shopInfo?.rating || 0}
                              className="mt-1"
                              disabled
                            />
                            <small className="ml-1">
                              ({shopInfo?.numberOfRating || 0})
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <ShopSidebar shopId={shopId} />
              </Card>
            </Col>
            <Col span={18}>
              <Card
                className="product-information-show-tab-wrapper"
                size="small"
              >
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

ShopLayout.propType = {
  children: PropTypes.element,
};

export default ShopLayout;
